import notes from './notes.reducer';

export default notes;
